import { render, staticRenderFns } from "./FooterSocialAboutUs.vue?vue&type=template&id=11e831b6&"
import script from "./FooterSocialAboutUs.vue?vue&type=script&lang=js&"
export * from "./FooterSocialAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports